import React, { FC, ReactElement } from 'react';
import { useAppSelector } from '../../hooks/useRedux';
import CustomerHandoff from '../CustomerHandoff';
import Inspection from '../Inspection';
import Order from '../Order';
import Payments from '../Payments';
import PricingPurchaseAgreement from '../PricingPurchaseAgreement';
import Production from '../Production';
import Reservation from '../Reservation';
import ScheduleDelivery from '../ScheduleDelivery';
import StageInfo from '../StageInfo';
import Transit from '../Transit';
import VehicleRegistration from '../VehicleRegistration';

const VehicleStage: FC = () => {
  const stage = useAppSelector((state) => state.vehicle.selectedStage);

  const components: Record<string, unknown> = {
    Reserved: <Reservation />,
    Ordered: <Order />,
    Production: <Production />,
    Transit: <Transit />,
    Inspection: <Inspection />,
    Registration: <StageInfo />,
    Pricing: <PricingPurchaseAgreement />,
    Payments: <Payments />,
    Delivery: <ScheduleDelivery />,
    CustomerHandoff: <CustomerHandoff />,
    VehicleRegistration: <VehicleRegistration />,
  };

  return (components[stage] || <Reservation />) as ReactElement;
};

export default VehicleStage;
